'use client';

import type { EnterApiTransport } from '../http/api-module-deps';
import { useEnterApiDomainInstance } from './enter-api-provider';

export type EnterApiDomainFactory<TDomain> = (transport: EnterApiTransport) => TDomain;

/** 使用 Provider 的共享传输依赖，按 factory 在当前 Provider scope 复用领域客户端。 */
export function useEnterApiDomain<TDomain>(factory: EnterApiDomainFactory<TDomain>): TDomain {
    return useEnterApiDomainInstance(factory);
}
